
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'DBPVACVV',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/DBPVACVV.vue